import { Badge } from '@/components/badge';

export function DiscountBadge({
  price,
  compareAtPrice,
}: { price: number; compareAtPrice: number }) {
  if (price === 0 || compareAtPrice === 0) return null;

  if (price >= compareAtPrice) return null;

  const discount = ((compareAtPrice - price) / compareAtPrice) * 100;

  if (discount === 0) return null;

  return <Badge>-{discount.toFixed(0)}%</Badge>;
}
